import { configureAttachments } from '../../components/attachments'
import { configureCheckboxActionButton } from '../../components/checkbox'
import { initEmailStatusModal } from '../../components/email_status'

function initApplicantDetail() {
  const getApplicantId = () => {
    const el = document.querySelector<HTMLElement>('#applicant-id')
    return el?.dataset.applicantId
  }
  initEmailStatusModal()

  configureAttachments({
    renderNoAttachmentPath:
      '/partner/applicants/attachments/render_no_attachment',
    renderUploadedPath: '/partner/applicants/attachments/render_uploaded',
    deleteAttachmentPath: `/api/v1/applicant/${getApplicantId()}/attachment/`,
    createAttachmentPath: `/api/v1/applicant/${getApplicantId()}/create_attachment`,
    pendingAttachmentPath: '/partner/applicants/attachments/render_pending',
  })

  const buttonExportSelected = document.getElementById(
    'btn-export-selected',
  ) as HTMLButtonElement
  const checkboxes = document.getElementsByName(
    'application',
  ) as NodeListOf<HTMLInputElement>
  configureCheckboxActionButton(buttonExportSelected, checkboxes)
}

export { initApplicantDetail }
